import Api from '../../../../shared/Api';

class GenericOrderApi {
    static newGenericOrder(orderCollectionId: number): any {
        return new Api().get(`/views/orders/generic/new?orderCollectionId=${orderCollectionId}`);
    }

    static createGenericOrder(genericOrder): any {
        return new Api().post('/views/orders/generic/create', genericOrder);
    }
}

export default GenericOrderApi;
